<template>
  <div>
    <SLandingTopBar v-if="!this.isUserAuthenticated"/>
    <SLoggedHeader v-else :userId="logged.id" :userName="logged.firstName" :profileUserName="logged.username" ref="sLoggedHeader" />
    <SSubHeader pageName="User inventory" :backButton="true" />
    <div class="header-spacer"></div>
    <div :key="pageKey">
      <SPreloader />
      <HeaderInventory :userProfile="user" @selectedTab="setTab"/>
      <div class="container d-flex flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row">
        <div class="left-bar col col-lg-3 col-xl-3 no-padding" v-if="showProfile" >
          <ProfileAboutMe :about="user"/>
        </div>
        <div class="profile-feed">
          <ProfileCategories
            v-if="this.$route.name === 'InventoryItems' || this.$route.name === 'InventoryItemsCategory'"
            class="category-buttons"
            :categories="categories"
            @categoryButton="makeFilter"
            :userInfo="user"
          />
          <div class="d-flex w-100 justify-content-between right-space">
            <router-view :userProfile="user" :items="items" :filter="categoryFilter"></router-view>
          </div>
        </div>

      </div>
      <div>
        <a class="back-to-top arrow-top" href="#" v-if="pageBottom">
          <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
        </a>
      </div>
    </div>
    <FooterUnlogged />
  </div>
</template>
<script>
import HeaderInventory from "@/components/organisms/HeaderInventory";
import UserHelper from "../mixins/UserHelper";
// import store from "@/vuex/store";
import SPreloader from "@/components/organisms/SPreloader.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import ProfileCategories from "@/material-components/molecules/ProfileCategories.vue";
import ProfileAboutMe from '../components/molecules/ProfileAboutMe.vue';
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SLoggedHeader from "@/templates/SLoggedHeader";
import axios from 'axios';
import Global from '../constants/Global';
import FooterUnlogged from "@/templates/FooterUnlogged";

const headers = {
  'Content-Type': 'application/json'
};

export default {
  name: "InventoryPage",
  data() {
    return {
      pageKey: 0,
      showProfile: false,
      user: [],
      items: [],
      loggedUser: null,
      categories: [
        {
          name: "free",
          categoryId: 13,
          icon: "sell",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/free?filter=13",
        },
        {
          name: "book",
          categoryId: 8,
          icon: "book",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/book?filter=8",
        },
        {
          name: "auto",
          categoryId: 5,
          icon: "directions_car",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/auto?filter=5",
        },
        {
          name: "clothing",
          categoryId: 3,
          icon: "checkroom",
          iconClass: "material-icons clothing-class",
          searchQuery: "/s-app/search-result/clothing?filter=3",
        },
        {
          name: "electronic",
          categoryId: 2,
          icon: "phone_android",
          iconClass: "material-icons electronic-class",
          searchQuery: "/s-app/search-result/electronic?filter=2",
        },
        {
          name: "family",
          categoryId: 9,
          icon: "child_friendly",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/family?filter=9",
        },
        {
          name: "games",
          categoryId: 10,
          icon: "sports_esports",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/games?filter=10",
        },
        {
          name: "household",
          categoryId: 1,
          icon: "maps_home_work",
          iconClass: "material-icons-outlined household-class",
          searchQuery: "/s-app/search-result/household?filter=1",
        },
        {
          name: "music",
          categoryId: 4,
          icon: "library_music",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/music?filter=4",
        },
        {
          name: "sports",
          categoryId: 11,
          icon: "sports_football",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/sports?filter=11",
        },
        {
          name: "tools",
          categoryId: 12,
          icon: "build",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/tools?filter=12",
        },
        {
          name: "video",
          categoryId: 6,
          icon: "duo",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/video?filter=6",
        },
        {
          name: "other",
          categoryId: 7,
          icon: "more_horiz",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/other?filter=7",
        },
      ],
      categoryFilter: {},
      logged: {}
    };
  },
  components: {
    HeaderInventory,
    SLoggedHeader,
    SPreloader,
    SSubHeader,
    SLandingTopBar,
    ProfileCategories,
    FooterUnlogged,
    ProfileAboutMe
  },
  mixins: [UserHelper],
  computed: {
    // ...mapGetters({
    //   getUser: "getUser",
    // }),
  },
  methods: {
    makeFilter(value){
      if (value !== null) {
        this.categoryFilter = value
      } else {
        this.categoryFilter = {}
      }
    },
    handleResize() {
      this.showProfile = window.innerWidth > 1024;
    },
    setTab(e) {
      this.pageKey= e;
    },
  },
  async created() {
    const inventory = await axios.get(Global.getServerDomain() + '/inventory?query=' + this.$route.params.username, { headers });

    this.user = inventory.data[0];
    this.items = inventory.data[1];

    this.logged = JSON.parse(localStorage.getItem('loggedUser'))

    const route_params = this.$route.params

    if(route_params.category) {
      const category_from_params = this.categories.find(el => Object.values(el).includes(route_params.category))

      this.categoryFilter = category_from_params
    }
  },
  async mounted() {
    this.showProfile = window.innerWidth > 1024;
    window.addEventListener('resize', this.handleResize);
  },
};
</script>

<style>
  .update-btn {
    display: flex;
    justify-content: right;
    flex: 25%;
    max-width: 100%;
  }
  .update-btn button {
    width: 175px;
    padding: 1rem 1rem;
  }
</style>

<style scoped>
.user-avatar {
  width: 100% !important;
  height: 100% !important;
}
.container {
  max-width: 1628px;
  padding: 0 64px;
  margin: auto !important;
}
.profile-feed {
  max-width: 85%;
  min-width: 85%;
}
.right-space {

  flex-direction: column;
  height: 100%;
}
.category-buttons {
  max-width: 100%;
}
.left-bar {
  flex: unset;
  margin-right: 8px;
  min-width: 15%;
  max-width: 15%;
}
.share-input-design {
  display: flex;
  align-items: center;
  border: 1px solid gray;
  border-radius: 10px;
}
.share-input {
  border: none;
}
.copy-button {
  width: 15%;
  cursor: pointer;
  color: #05919B;
}
@media screen and (max-width: 1024px) {
  .profile-feed {
    max-width: 100%;
    min-width: 100%;
  }
}
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-track {
  display: none;
}
::-webkit-scrollbar-track-piece {
  display: none;
}
::-webkit-scrollbar-thumb {
  display: none;
}
::-webkit-scrollbar:horizontal{
  display: none;
}
::-webkit-scrollbar:vertical{
  display: none;
}
</style>
